import { useEffect, useRef, useState } from "react"
import { upperFirst } from "lodash"
import { isServerRendered } from "../../../utils/is-server-rendered"
import { Template } from "./template"

function useForceUpdate() {
  const [, setState] = useState(Object.create(null))
  return () => {
    setState(Object.create(null))
  }
}

export function useTemplate({ name, url, layout }, templates) {
  const ref = useRef()

  const forceUpdate = useForceUpdate()

  const displayName = `${name} ${layout || ""}`
    .split(/\s|-/)
    .map(upperFirst)
    .join("")

  if (isServerRendered) {
    ref.current = templates[displayName]
  }

  useEffect(() => {
    async function loadLayout() {
      const template = Template({ name, url })
      ref.current = await template.layout(layout)
      forceUpdate()
    }

    if (url) {
      loadLayout()
    } else if (templates[displayName]) {
      ref.current = templates[displayName]
      forceUpdate()
    }

    return () => {
      if (ref.current?.cleanup) ref.current.cleanup()
    }
  }, [displayName, layout])

  if (ref.current && ref.current.displayName !== displayName) {
    return undefined
  } else if (typeof ref.current === "function") {
    return ref.current
  } else {
    return undefined
  }
}
